import { navigateTo } from '../../lib/js/navigateTo'
import { parseTime } from '../../lib/js/util'
import store from '../../store'

import { query as webxQuery } from '@didi/webx-js'

export function toIndex(params = {}) {
  params.openid = store.getters.openid || ''
  params.cityid = webxQuery().cityid
  params.only_show_cate = webxQuery().only_show_cate
  // navigateTo中处理链接转换
  navigateTo({
    pathname: 'index',
    query: params,
  })
}

export function createForecast(start, current, end) {
  const dayTextList =
    store.getters.lang === 'zh-CN'
      ? ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
      : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  const startObj = parseTime(new Date(start))
  const endObj = parseTime(new Date(end))
  const currentObj = parseTime(new Date(current))

  const startSec = startObj.millisec
  const endSec = endObj.millisec
  const currentSec = currentObj.millisec

  const startSecRegular = new Date(
    `${startObj.year}/${startObj.month}/${startObj.date}`
  )
  const currentSecRegular = new Date(
    `${currentObj.year}/${currentObj.month}/${currentObj.date}`
  )
  const timeGapRegular = startSecRegular - currentSecRegular
  const dayText = dayTextList[startObj.day]

  const startTimeGap = startSec - currentSec // 距开始
  const endTimeGap = endSec - currentSec // 距结束
  return {
    timeGapRegular,
    startTimeGap,
    endTimeGap,
    startSecRegular,
    currentSecRegular,
    dayTextList,
    dayText,
    startObj,
    endObj,
    currentObj,
  }
}
